export default function Home2() {
  return (
    <div className="max-w-4xl mx-auto p-8 font-serif">
      <h1 className="text-3xl font-bold mb-6">
        Welcome to the Homepage of
        <br />
        The Seedling Monastery – Plum Village Thailand
      </h1>

      <div className="flex flex-col md:flex-row gap-8 items-start">
        <div className="flex-grow space-y-4">
          <p>
            The online homepage is a place where you can find mindfulness
            practice guidelines for daily life.
          </p>
          <p>
            By visiting this homepage, you are <em>returning to yourself</em>,
            giving yourself the chance to recognize the conditions of happiness
            that are present, smile, and live fully in each moment.
          </p>
          <p>
            The homepage will also frequently update information about events
            such as Retreats or Mindfulness Days, alongside regular schedules
            like sitting meditation, chanting, walking meditation, precepts
            recitation, Dharma talks, Dharma sharing on practice, chanting
            mindfulness songs, and eating in silence.
          </p>
          <p>
            This homepage is also a space where you will learn how to plant the
            seeds of love, bring mindfulness into your everyday life, and
            cultivate happiness within yourself, your family, friends, and
            society.
          </p>
          <p>
            The Sangha is grateful for your practice and wishes you much joy in
            your life!
          </p>
        </div>

        <div className="flex-shrink-0">
          <img
            src="https://static.wixstatic.com/media/b4e2e4_e243fdcc4d08435fbe65e83220e2a4e9~mv2.png/v1/fill/w_406,h_380,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Artboard%201.png"
            alt="Breathe and Smile calligraphy"
            width={200}
            height={200}
            className="rounded-full"
          />
        </div>
      </div>
    </div>
  );
}
